import React from 'react';

function Filter({ 
  categories, 
  techniques, 
  tactics, 
  versions, 
  onFilter, 
  selectedCategory, 
  selectedTechniques, 
  selectedTactics, 
  selectedVersions, 
  setSelectedCategory, 
  setSelectedTechniques, 
  setSelectedTactics, 
  setSelectedVersions 
}) {

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    const newCategory = category === 'All' ? [] : [category];
    setSelectedCategory(newCategory);
    onFilter(newCategory, selectedTechniques, selectedTactics, selectedVersions);
  };

  const handleTechniqueChange = (e) => {
    const technique = e.target.value;
    const newTechniques = technique === 'All' ? [] : [technique];
    setSelectedTechniques(newTechniques);
    onFilter(selectedCategory, newTechniques, selectedTactics, selectedVersions);
  };

  const handleTacticChange = (e) => {
    const tactic = e.target.value;
    const newTactics = tactic === 'All' ? [] : [tactic];
    setSelectedTactics(newTactics);
    onFilter(selectedCategory, selectedTechniques, newTactics, selectedVersions);
  };

  const handleVersionChange = (e) => {
    const version = e.target.value;
    const newVersions = version === 'All' ? [] : [version];
    setSelectedVersions(newVersions);
    onFilter(selectedCategory, selectedTechniques, selectedTactics, newVersions);
  };

  return (
    <div className="filter">
      
      <div className="filter-controls">
        <div className="filter-category">
          <label htmlFor="category">Category</label>
          <select id="category" onChange={handleCategoryChange} value={selectedCategory.length > 0 ? selectedCategory[0] : 'All'}>
            <option value="All">All Category</option>
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>

        <div className="filter-techniques">
          <label htmlFor="techniques">MITRE Techniques</label>
          <select id="techniques" onChange={handleTechniqueChange} value={selectedTechniques.length > 0 ? selectedTechniques[0] : 'All'}>
            <option value="All">All Techniques</option>
            {techniques.map(technique => (
              <option key={technique} value={technique}>{technique}</option>
            ))}
          </select>
        </div>

         <div className="filter-tactics">
          <label htmlFor="tactics">MITRE Tactics</label>
          <select id="tactics" onChange={handleTacticChange} value={selectedTactics.length > 0 ? selectedTactics[0] : 'All'}>
            <option value="All">All Tactics</option>
            {tactics.map(tactic => (
              <option key={tactic} value={tactic}>{tactic}</option>
            ))}
          </select>
        </div>

        <div className="filter-versions">
          <label htmlFor="versions">Volatility Version</label>
          <select id="versions" onChange={handleVersionChange} value={selectedVersions.length > 0 ? selectedVersions[0] : 'All'}>
            <option value="All">All Versions</option>
            {versions.map(version => (
              <option key={version} value={version}>{version}</option>
            ))}
          </select>
        </div>

       
      </div>
    </div>
  );
}

export default Filter;
